import { takeEvery, fork, put, all, call, select } from "redux-saga/effects"

// Login Redux States
import { EDIT_PROFILE } from "./actionTypes"
import { profileSuccess, profileError } from "./actions"
import { apiError, loginSuccess, logoutUserSuccess } from "../login/actions"

import config from "../../../config/config"
import axios from "axios"

//Include Both Helper File with needed methods

function updateProfileAPI(bodyData, token) {
  return axios.put(`${config.backendUrl}/auth/update`, bodyData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Specify JSON format
    },
  })
}

const getToken = state => state.Login.userData.token

function* editProfile({ payload: { user } }) {
  try {
    if (Object.keys(user).length == 0) {
      yield put(profileError("Nothing to Update"))
      return
    }
    // Get the user token from Redux state using select effect
    const token = yield select(getToken)

    // Make the API call using the plain object instead of FormData
    const response = yield call(updateProfileAPI, user, token)

    // Dispatch success action with the response message
    yield put(loginSuccess(response.data.userInfo))
    yield put(profileSuccess(response.data.message))
  } catch (error) {
    // Dispatch error action with the error message
    yield put(profileError(error.response?.data || "Error updating profile"))
  }
}
export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
